<template>
  <div class="vx-card p-6">
    <template v-if="filters.length">
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <h3>Filters</h3>
        </div>
      </div>
      <div class="vx-row" v-for="(row, i) in filters" :key="i">
        <template v-for="(F, j) in row">
          <div
            v-if="F.type == 'date'"
            :key="j"
            :class="`vx-col md:w-${F.width} sm:w-${F.width} w-full`"
          >
            <label class="text-sm opacity-75">{{ F.label }}</label>
            <flat-pickr
              :config="F.options"
              style="width: 100%"
              v-model="filter.start_time"
            />
          </div>
          <div
            v-else-if="F.type == 'select'"
            :key="j"
            :class="`vx-col md:w-${F.width} sm:w-${F.width} w-full`"
          >
            <label class="text-sm opacity-75">{{ F.label }}</label>
            <v-select
              :options="F.options"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="filter[F.name]"
              class="mb-4 md:mb-0"
            />
          </div>
          <div
            v-else-if="F.type == 'action'"
            :key="j"
            :class="`vx-col md:w-${F.width} sm:w-${F.width} w-full`"
          >
            <vs-button
              id="searchBtn"
              style="width: 100%"
              :color="F.options.color"
              type="filled"
              icon-pack="feather"
              :icon="F.options.icon"
              class="pl-5 mt-1 vs-con-loading__container"
              @click="doFilter"
              >{{ F.options.text }}</vs-button
            >
          </div>
        </template>
      </div>
      <vs-divider></vs-divider>
    </template>

    <div class="flex flex-wrap items-center">
      <div class="flex-grow">
        <slot name="action"></slot>
      </div>
      <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
        <div
          class="
            p-4
            border border-solid
            d-theme-border-grey-light
            rounded-full
            d-theme-dark-bg
            cursor-pointer
            flex
            items-center
            justify-between
            font-medium
          "
        >
          <span class="mr-2"
            >{{ rowFrom }} - {{ rowTo }} of {{ rowTotal }}</span
          >
          <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
        </div>
        <vs-dropdown-menu>
          <vs-dropdown-item @click="updatePerPage(10)">
            <span>10</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="updatePerPage(25)">
            <span>25</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="updatePerPage(50)">
            <span>50</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="updatePerPage(100)">
            <span>100</span>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
      <vs-input
        class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
        v-model="params.search"
        @keyup="search"
        placeholder="Search..."
      />
    </div>
    <div class="table-container">
      <table class="table">
        <thead>
          <tr v-for="(tr, key) in headers" :key="key">
            <th v-if="key == 0" :rowspan="headers.length">No.</th>
            <th
              v-for="(header, key) in tr"
              :key="key"
              :style="header.style || ''"
              :class="header.class || ''"
              :rowspan="header.rowspan || 1"
              :colspan="header.colspan || 1"
            >
              {{ header.label }}
            </th>
            <th v-if="enableActions && key == 0" :rowspan="headers.length">
              Actions
            </th>
          </tr>
        </thead>
        <tbody v-if="loading">
          <tr>
            <td colspan="100" class="text-center">Loading....</td>
          </tr>
        </tbody>
        <tbody v-else-if="data.length">
          <tr v-for="(item, index) in data" :key="item[primary]">
            <td>{{ (params.page - 1) * params.per_page + (index + 1) }}</td>
            <td
              v-for="(header, key) in formattedHeaders"
              :key="key"
              :style="header.colStyle || ''"
              :class="header.colClass || ''"
              v-html="showData(header, item)"
            />
            <td
              v-if="enableActions"
              :style="`width: ${actions.length * 30 + 30}px`"
            >
              <div class="flex justify-center">
                <vx-tooltip
                  v-for="(action, i) in actions"
                  :text="action.name"
                  :key="i"
                  position="top"
                >
                  <template v-if="getType(action.condition) !== 'undefined'">
                    <vs-button
                      :id="`btn${camelize(action.name)}_${item[primary]}`"
                      type="border"
                      size="small"
                      icon-pack="feather"
                      :icon="action.icon || `icon-edit`"
                      :color="action.color || `primary`"
                      class="mr-2 vs-con-loading__container"
                      @click="callAction(action, item[primary])"
                      v-if="action.condition(item)"
                    />
                  </template>

                  <vs-button
                    v-else
                    :id="`btn${camelize(action.name)}_${item[primary]}`"
                    type="border"
                    size="small"
                    icon-pack="feather"
                    :icon="action.icon || `icon-edit`"
                    :color="action.color || `primary`"
                    class="mr-2 vs-con-loading__container"
                    @click="callAction(action, item[primary])"
                  />
                </vx-tooltip>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="100" class="text-center">No Data Available</td>
          </tr>
        </tbody>
      </table>
      <vs-pagination :total="n_page" v-model="params.page"></vs-pagination>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
    flatPickr
  },
  props: {
    primary: { type: String, default: 'id' },
    module: { type: String, required: true },
    autoInit: { type: Boolean, default: true },
    headers: { type: Array, required: true },
    enableActions: { type: Boolean, default: true },
    actions: {
      type: Array,
      default: () => {
        return []
      }
    },
    filters: {
      type: Array,
      default: () => {
        return []
      }
    },
    autoFilter: { type: Boolean, default: true }
  },
  data() {
    return {
      loading: true,
      timer: null,
      params: {
        page: 1,
        search: null,
        per_page: 10
      },
      filter: {},
      filtered: {}
    }
  },
  computed: {
    data() {
      return this.$store.state[this.module].data
    },
    rowTotal() {
      return this.$store.state[this.module].total
    },
    rowFrom() {
      return (
        this.params.page * this.params.per_page - (this.params.per_page - 1)
      )
    },
    rowTo() {
      return this.rowTotal - this.params.page * this.params.per_page > 0
        ? this.params.page * this.params.per_page
        : this.rowTotal
    },
    n_page() {
      return Math.ceil(this.rowTotal / this.params.per_page)
    },
    formattedHeaders() {
      const headers = []
      this.headers.map((tr) => {
        tr.map((td) => {
          if (typeof td.value !== 'undefined') headers.push(td)
        })
      })
      return headers
    },
    page() {
      return this.params.page
    }
  },
  watch: {
    page() {
      this.initTable()
    },
    per_page() {
      if (this.params.page != 1) this.params.page = 1
      else this.initTable()
    },
    filter: {
      handler() {
        if (this.autoFilter) {
          if (this.params.page == 1) this.initTable()
          else this.params.page = 1
        }
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    if (this.autoInit) this.initTable()
  },
  methods: {
    search() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.params.page = 1
        this.initTable()
      }, 800)
    },
    updatePerPage(n) {
      this.params.per_page = n
      this.initTable()
    },
    async initTable() {
      const f = {}
      await Object.keys(this.filter).map((i) => {
        if (typeof this.filter[i] !== 'undefined')
          f[i] = this.filter[i] ? this.filter[i].value : ''
      })

      this.loading = true
      await this.$store.dispatch(`${this.module}/datatable`, {
        ...this.params,
        ...f
      })
      this.loading = false
    },
    async doFilter() {},
    showData(header, data) {
      let value
      const splitValue = header.value.split('.')
      if (splitValue.length > 1) {
        value = data[splitValue[0]]
        splitValue.splice(0, 1)

        if (value) {
          splitValue.map((key) => {
            value = value[key] ? value[key] : '-'
          })
        }
      } else {
        value = data[header.value]
      }

      return header.formatter ? header.formatter(value) : value
    },
    async callAction(action, primary) {
      this.loadingStart(
        `#btn${this.camelize(action.name)}_${primary}`,
        action.color
      )
      await action.action(primary)
      this.loadingStop(`#btn${this.camelize(action.name)}_${primary}`)
    },
    camelize(str) {
      return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
          return index === 0 ? word.toLowerCase() : word.toUpperCase()
        })
        .replace(/\s+/g, '')
    },
    loadingStart(el, color) {
      this.$vs.loading({
        background: color,
        color: '#fff',
        container: el,
        scale: 0.45
      })
    },
    loadingStop(el) {
      this.$vs.loading.close(`${el} > .con-vs-loading`)
    },
    getType(data) {
      return typeof data
    }
  }
}
</script>
